export const HUBBLE_TO_COUNTLY_PV = 'hubble_to_countly_pv'

const originEventPrfix = 'cly_e_'
export const CLY_E_PV = `${originEventPrfix}pv`